import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { FullPageSlotsRoute } from '@/app/FullPageSlotsRoute';
import type { PageStaticData } from '@/shared/routing';

// Today's full-page app slots (`routes/_authenticated/apps/$.tsx`), in the new navigation's shell.
export const Route = createFileRoute('/_authenticated/next/apps/$')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    // As today's route: the path and fragment come from the match, not from the router's location.
    beforeLoad: ({ location }) => ({ urlPathname: location.href.split(/[?#]/, 1)[0], urlHash: location.hash }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const urlPathname = Route.useRouteContext({ select: (context) => context.urlPathname });
    const urlHash = Route.useRouteContext({ select: (context) => context.urlHash });
    // The manifests declare every widget route under `/apps`, so the slots match the path without `/next`.
    return <FullPageSlotsRoute pathname={urlPathname.slice('/next'.length)} hash={urlHash} inNewNavigation />;
}
